import React from "react";

import Profile from "./profile/Profile";

export const Account = () => {
  console.log("account...........");
  return <Profile />;
};
